<div class="entity-card">
  
  <div class="section-body">
    <div class="aoa-row">
      <span class="aoa-row__label">
        Please choose one of the following options
      </span>

      <span class="aoa-row__value">
        {{ aoaText }}
      </span>
    </div>
  </div>
  
  <div class="section-body" *ngIf="associationArticleByLaws">
    <div class="aoa-row">
      <span class="aoa-row__label">
        Please choose one of the following options
      </span>

      <span class="aoa-row__value">
        {{ aoa2Text }}
      </span>
    </div>
  </div>
</div>
